const readEnvValue = (key: string): string | undefined => {
  const env = import.meta.env as Record<string, string | undefined>;
  return env[key];
};

export const getEnv = (key: string, fallback = ''): string => {
  // Normalize NEXT_PUBLIC_ keys to VITE_ for backward compat during transition
  const viteKey = key.startsWith('VITE_')
    ? key
    : `VITE_${key}`;

  return readEnvValue(viteKey) ?? readEnvValue(key) ?? fallback;
};
